import '.m{width:100%;}.ssr-plugin'
import '.an{max-width:1280px;}.ssr-plugin'
import '.ap{margin:0 auto;}.ssr-plugin'
import '.bs{margin-bottom:96px;}.ssr-plugin'
import '.ai{position:relative;}.ssr-plugin'
import '.bt{animation:votingTitleSlideIn 0.6s ease-out both;}.ssr-plugin'
import '.bu{container-type:inline-size;}.ssr-plugin'
import '.bv{display:none;}.ssr-plugin'
import '.bw{font-size:72px;}.ssr-plugin'
import '.bx{line-height:0.9;}.ssr-plugin'
import '.b2{display:grid;}.ssr-plugin'
import '.by{grid-template-columns:repeat(auto-fit, minmax(206px, 1fr));}.ssr-plugin'
import '.bz{gap:24px;}.ssr-plugin'
import '.c0{margin:96px auto;}.ssr-plugin'
import '.c1{padding:48px;}.ssr-plugin'
import '.e{display:flex;}.ssr-plugin'
import '.f{flex-direction:column;}.ssr-plugin'
import '.w{align-items:center;}.ssr-plugin'
import '.c2{overflow:hidden;}.ssr-plugin'
import '.c3{border-radius:32px;}.ssr-plugin'
import '.c4{-webkit-backdrop-filter:blur(16px);}.ssr-plugin'
import '.c5{backdrop-filter:blur(16px);}.ssr-plugin'
import '.c6{width:500px;}.ssr-plugin'
import '.o{height:500px;}.ssr-plugin'
import '.ab{border-radius:50%;}.ssr-plugin'
import '.c7{right:-250px;}.ssr-plugin'
import '.c8{top:-250px;}.ssr-plugin'
import '.c9{filter:blur(96px);}.ssr-plugin'
import '.a6{position:absolute;}.ssr-plugin'
import '.bb{z-index:0;}.ssr-plugin'
import '.ca{gap:96px;}.ssr-plugin'
import '.h{flex:1;}.ssr-plugin'
import '.bo{text-align:left;}.ssr-plugin'
import '.cb{gap:16px;}.ssr-plugin'
import '.cc{gap:12px;}.ssr-plugin'
import '.cd{justify-content:start;}.ssr-plugin'
import '.ce{font-size:16px;}.ssr-plugin'
import { useEffect, useState } from 'react'
import { styled } from 'inlines'
import { Card } from '../components/Card.js'
import { ContestantModal } from '../components/ContestantModal.js'
import { Layout } from '../components/Layout.js'
import { colors } from '../utils/colors.js'
import { useTrack } from '../hooks/useTrack.js'
import { AnalyticsEvent } from '../../../shared/analyticsEvents.js'
import { Banner } from '../components/Banner.js'
import { useVotingRegion } from '../hooks/useVotingRegion.js'
import { TABLET, MOBILE } from '../utils/breakpoints.js'
import { useLanguage } from '../hooks/useLanguage.js'
import { useSafeLocalStorage } from '../hooks/useSafeLocalStorage.js'
import { RecapVideo } from '../components/RecapVideo.js'
import { useScrollToTop } from '../hooks/useScrollToTop.js'
import { parseContestantImageSrc } from '../utils/parseImageSrc.js'
import { useDictionary } from '../hooks/useDictionary.js'
import { Icon } from '../assets/icons/index.js'

export const VotingPage = ({
  votes,
  setVotes,
  round,
  rounds = [] as any,
  name,
  ...props
}) => {
  let { contestants = [], recapVideo } = props

  const [votingRegion] = useVotingRegion()
  const { maxVotes, voteType } = votingRegion
  const currentRound = rounds.find((r: any) => r.id === round?.id)

  const {
    votingPromptLong,
    votingPromptShort,
    votingReminder,
    tutorialMaxVotes,
    tutorialVotePrice,
    tutorialCardLimit,
    tutorialLostVotes,
    tutorialSMSVoting,
    tutorialSMSVotingCount,
  } = useDictionary()

  const ddiByRegion: Record<string, string> = {}
  for (const c of currentRound?.contestants ?? []) {
    ddiByRegion[c.votingRegionCode] = c.ddi
  }

  contestants = contestants
    .filter((c: any) => ddiByRegion[c.votingRegion])
    .sort(
      (a: any, b: any) =>
        Number(ddiByRegion[a.votingRegion]) -
        Number(ddiByRegion[b.votingRegion]),
    )

  const [watchedRecap, setWatchedRecap] = useSafeLocalStorage<boolean>(
    `watchedRecap-${name}`,
    false,
    (v) => typeof v === 'boolean',
  )
  const [lang] = useLanguage()
  const total = Object.values<number>(votes ?? {}).reduce((a, b) => a + b, 0)
  if (maxVotes === undefined) console.warn('VotingPage: maxVotes missing')
  const maxed = total >= (maxVotes ?? 0) // SAFE: zero when maxVotes not yet loaded

  const [openModal, setOpenModal] = useState<boolean>(false)
  const track = useTrack('voting')

  useScrollToTop()

  useEffect(() => {
    track(AnalyticsEvent.PAGE_LOAD)
  }, [])

  const [modalIndex, setModalIndex] = useState<number>(0)

  return (
    <>
      <Layout>
        <main className="m an ap"
          id="voting-page-content"
        >
          <div>
            <styled.h1 className="bs ai bt"
              style={{
                color: colors.primary,
                '@keyframes votingTitleSlideIn': {
                  from: {
                    opacity: 0,
                    bottom: '-48px',
                  },
                  to: {
                    opacity: 1,
                    bottom: '0px',
                  },
                },
                [TABLET]: { display: 'none' },
              }}
            >
              {votingPromptLong}
            </styled.h1>
          </div>
          <styled.div className="m bu"
            style={{
              [TABLET]: {
                marginBottom: '76px',
              },
            }}
          >
            <styled.h1 className="bv ai bw bx"
              style={{
                color: colors.primary,
                [TABLET]: {
                  display: 'block',
                  animation: 'voteMainSlideIn 0.6s ease-out forwards',
                  '@keyframes voteMainSlideIn': {
                    from: { opacity: 0, transform: 'translateY(-72px)' },
                    to: { opacity: 1, transform: 'translateY(0)' },
                  },
                  '@keyframes voteBeforeSlideIn': {
                    from: {
                      opacity: 0,
                      transform: 'translateY(calc(200% - 72px))',
                    },
                    to: { opacity: 0.25, transform: 'translateY(200%)' },
                  },
                  '@keyframes voteAfterSlideIn': {
                    from: {
                      opacity: 0,
                      transform: 'translateY(calc(100% - 72px))',
                    },
                    to: { opacity: 0.5, transform: 'translateY(100%)' },
                  },

                  '&::before': {
                    content: `"${votingPromptShort?.toUpperCase()}"`,
                    position: 'absolute',
                    margin: '0 auto',
                    top: 0,
                    left: 0,
                    right: 0,
                    textAlign: 'center',
                    color: 'transparent',
                    transform: 'translateY(200%)',
                    WebkitTextStroke: `2px ${colors.primary}`,
                    opacity: 0,
                    animation: 'voteBeforeSlideIn 0.6s ease-out .2s forwards',
                  },
                  '&::after': {
                    content: `"${votingPromptShort?.toUpperCase()}"`,
                    position: 'absolute',
                    margin: '0 auto',
                    top: 0,
                    left: 0,
                    right: 0,
                    textAlign: 'center',
                    color: 'transparent',
                    transform: 'translateY(100%)',
                    WebkitTextStroke: `2px ${colors.primary}`,
                    opacity: 0,
                    animation: 'voteAfterSlideIn 0.6s ease-out .1s forwards',
                  },
                },
                [MOBILE]: {
                  fontSize: '18cqw',
                },
              }}
            >
              {votingPromptShort?.toUpperCase()}
            </styled.h1>
          </styled.div>
          <styled.div>
            {openModal && (
              <ContestantModal
                modalIndex={modalIndex}
                setModalIndex={setModalIndex}
                setModal={setOpenModal}
                amountOfContestants={contestants?.length}
                votes={votes}
                setVotes={setVotes}
                maxed={maxed}
                lang={lang}
                contestant={{
                  id: contestants[modalIndex].id,
                  img: parseContestantImageSrc(
                    contestants[modalIndex].image?.src,
                    324,
                  ),
                  ddi:
                    ddiByRegion[contestants[modalIndex].votingRegion] ?? '00', // SAFE: '00' when DDI not yet loaded
                  name: contestants[modalIndex].name,
                  song: contestants[modalIndex].song,
                  votingRegion: contestants[modalIndex].votingRegion,
                  lyrics: contestants[modalIndex].lyrics,
                }}
                rtl={lang.rtl}
              />
            )}
            <styled.div className="m b2 by bz"
              id="voting-page-contestants-wrapper"
              style={{
                [TABLET]: {
                  gridTemplateColumns: 'repeat(auto-fit, minmax(144px, 1fr))',
                },
              }}
            >
              {contestants?.map((item, idx) => {
                return (
                  <Card
                    img={item.image?.src}
                    ddi={ddiByRegion[item.votingRegion]}
                    name={item.name}
                    song={item.song}
                    votingRegion={item.votingRegion}
                    setModal={setOpenModal}
                    setModalIndex={() => setModalIndex(idx)}
                    key={item.id}
                    votes={votes}
                    setVotes={setVotes}
                    maxed={maxed}
                  />
                )
              })}
            </styled.div>

            <styled.div className="c0 c1 e f w ai c2 c3 c4 c5"
              style={{
                border: `1px solid ${colors.border}`,
                [MOBILE]: {
                  border: 'none',
                  WebkitBackdropFilter: 'blur(0px)',
                  backdropFilter: 'blur(0px)',
                  margin: '24px auto',
                  borderRadius: '0px',
                  padding: '0px',
                },
                '&::before': {
                  content: '""',
                  width: 500,
                  height: 500,
                  borderRadius: '50%',
                  left: '-250px',
                  bottom: '-250px',
                  backgroundColor: colors.primary,
                  filter: 'blur(96px)',
                  background: `radial-gradient(circle,${colors.primary}0%, rgba(0, 0, 0, 0) 100%)`,
                  position: 'absolute',
                  [MOBILE]: { display: 'none' },
                },
              }}
            >
              {/* blurred right circle */}
              <styled.div className="c6 o ab c7 c8 c9 a6 bb"
                style={{
                  backgroundColor: colors.primary,
                  background: `radial-gradient(circle,${colors.blue}0%, rgba(0, 0, 0, 0) 100%)`,
                  [MOBILE]: { display: 'none' },
                }}
              />
              <styled.div className="bb ai e w m ca"
                style={{
                  [TABLET]: {
                    gap: '24px',
                    flexDirection: 'column',
                    alignItems: 'baseline',
                  },
                  [MOBILE]: {
                    flexDirection: 'column',
                    gap: '16px',
                  },
                }}
              >
                <styled.h2 className="h bo"
                  style={{
                    [TABLET]: {
                      fontSize: 'clamp(60px, 4vw, 80px)',
                    },
                    [MOBILE]: {
                      fontSize: '48px',
                      color: colors.primary,
                    },
                  }}
                >
                  {votingReminder
                    ?.split(/<accent>(.*?)<\/accent>/g)
                    .map((part, i) =>
                      i % 2 === 1 ? (
                        <span
                          style={{
                            color: colors.primary,
                          }}
                          key={i}
                        >
                          {part}
                        </span>
                      ) : (
                        part
                      ),
                    )}
                </styled.h2>
                <styled.div className="e h f cb"
                  style={{
                    [TABLET]: {
                      justifyContent: 'start',
                    },
                  }}
                >
                  <VotingInfoRow>
                    {tutorialMaxVotes?.replace(
                      /{{maxVotes}}/g,
                      maxVotes !== undefined ? String(maxVotes) : '',
                    )}
                  </VotingInfoRow>

                  <VotingInfoRow>{tutorialVotePrice}</VotingInfoRow>
                  <VotingInfoRow>
                    {voteType !== 'online'
                      ? tutorialSMSVotingCount
                      : tutorialCardLimit}
                  </VotingInfoRow>
                  <VotingInfoRow>
                    {voteType !== 'online'
                      ? tutorialSMSVoting
                      : tutorialLostVotes}
                  </VotingInfoRow>
                </styled.div>
              </styled.div>
            </styled.div>
          </styled.div>
        </main>
      </Layout>
      {voteType === 'online' && <Banner total={total} maxVotes={maxVotes} />}
      {recapVideo && votingRegion.code === 'ROW' && !watchedRecap && (
        <RecapVideo setWatchedRecap={setWatchedRecap} src={recapVideo?.src} />
      )}
    </>
  )
}

const VotingInfoRow = ({ children }: { children: React.ReactNode }) => (
  <div className="e cc cd bo"
  >
    <Icon
      type="infoIcon"
      style={{ opacity: 0.5, minWidth: 24, minHeight: 24 }}
    />
    <p className="ce">{children}</p>
  </div>
)
